"use client";

import type { PencilIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { FC } from "react";

interface Props {
  onClick?: () => void;
  disabled?: boolean;
  label: string;
  className?: string;
  size?: number;
  Icon: typeof PencilIcon;
  testId?: string;
}

export const IconButton: FC<Props> = ({
  onClick,
  disabled = false,
  label,
  size = 18,
  className = "",
  Icon,
  testId,
}) => (
  <button
    type="button"
    aria-label={label}
    disabled={disabled}
    onClick={onClick}
    data-testid={ testId }
    className={ clsx(
      disabled ? "text-slate-300" : null,
    )}
  >
    <Icon width={size} height={size} className={className}/>
  </button>
);
